import React, { useEffect } from "react";
import LayersIcon from '@mui/icons-material/Layers';
import ScienceIcon from '@mui/icons-material/Science';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import WaterDropIcon from '@mui/icons-material/WaterDrop';

const InventarioMaduracionSection = ({
  maduracionRecords,
  granelRecords,
  isFormOpen,
  setIsFormOpen,
  fechaMovimiento,
  setFechaMovimiento,
  noLote,
  setMadNoLote,
  categoria,
  setMadCategoria,
  clase,
  setMadClase,
  ingredientes,
  setMadIngredientes,
  edad,
  setMadEdad,
  tipoMaguey,
  setMadTipoMaguey,
  noAnalisis,
  setMadNoAnalisis,
  tipoRecipiente,
  setMadTipoRecipiente,
  detalleRecipiente,
  setMadDetalleRecipiente,
  invInicialFecha,
  setMadInvInicialFecha,
  invInicialRecipientes,
  setMadInvInicialRecipientes,
  invInicialVolumen,
  setMadInvInicialVolumen,
  invInicialAlc,
  setMadInvInicialAlc,
  entradaFolio,
  setMadEntradaFolio,
  entradaRecipientes,
  setMadEntradaRecipientes,
  entradaVolumen,
  setMadEntradaVolumen,
  entradaAlc,
  setMadEntradaAlc,
  salidaRecipientes,
  setMadSalidaRecipientes,
  salidaVolumen,
  setMadSalidaVolumen,
  salidaAlc,
  setMadSalidaAlc,
  salidaClaseObtenida,
  setMadSalidaClaseObtenida,
  salidaEdadObtenida,
  setMadSalidaEdadObtenida,
  salidaMerma,
  setMadSalidaMerma,
  invFinalRecipientes,
  setMadInvFinalRecipientes,
  invFinalVolumen,
  setMadInvFinalVolumen,
  invFinalAlc,
  setMadInvFinalAlc,
  observaciones,
  setMadObservaciones,
  handleSaveMaduracion
}) => {

  // Auto-fill features when selecting a source bulk lot
  useEffect(() => {
    if (noLote && noLote !== "manual") {
      const selected = (granelRecords || []).find(r => 
        r.noLote === noLote || 
        r.no_lote === noLote || 
        String(r.id) === String(noLote) || 
        String(r.id_bitacora_granel) === String(noLote)
      );
      if (selected) {
        if (selected.fechaMovimiento || selected.fecha) setFechaMovimiento(selected.fechaMovimiento || selected.fecha);
        if (selected.categoria) setMadCategoria(selected.categoria);
        if (selected.clase) setMadClase(selected.clase);
        if (selected.ingrediente || selected.ingredientes) setMadIngredientes(selected.ingrediente || selected.ingredientes);
        if (selected.edad) setMadEdad(selected.edad);
        const maguey = selected.tipoMaguey || selected.especie || selected.tipo_maguey || "";
        if (maguey) setMadTipoMaguey(maguey);
        const fq = selected.clave_fq || selected.claveFQ || selected.noAnalisis || selected.noAnalisisFisicoquimico || selected.no_analisis || "";
        setMadNoAnalisis(fq);
        if (selected.fechaMovimiento || selected.fecha) setMadInvInicialFecha(selected.fechaMovimiento || selected.fecha);
        const alc = selected.porcentaje_alc_vol || selected.invFinalAlc || selected.entradaAlc || selected.invInicialAlc || "";
        if (alc && setMadInvInicialAlc) setMadInvInicialAlc(alc);
      }
    }
  }, [noLote, granelRecords, setFechaMovimiento, setMadCategoria, setMadClase, setMadIngredientes, setMadEdad, setMadTipoMaguey, setMadNoAnalisis, setMadInvInicialFecha, setMadInvInicialAlc]);

  if (!isFormOpen) {
    return (
      <div className="animate-fadeIn">
        <div className="history-section-header">
          <h2>Inventarios de Mezcal a Granel en Proceso de Maduración (Sección VII)</h2>
          <button 
            onClick={() => setIsFormOpen(true)}
            className="btn-add-new"
          >
            <AddIcon style={{ fontSize: 18 }} />
            <span>Nuevo Registro de Maduración</span>
          </button>
        </div>

        <div className="records-list-wrapper">
          <table className="records-table">
            <thead>
              <tr>
                <th colSpan="6" style={{ textAlign: "center", background: "rgba(107, 142, 35, 0.2)", color: "var(--agave-green)" }}>Datos Generales / Identificación del Mezcal</th>
                <th colSpan="3" style={{ textAlign: "center" }}>Finalización</th>
              </tr>
              <tr>
                <th>Fecha Mov.</th>
                <th>Nº Lote</th>
                <th>Categoría</th>
                <th>Clase</th>
                <th>Ingredientes</th>
                <th>Edad</th>

                <th>Observaciones</th>
                <th>V.Bo. Inspector</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {maduracionRecords.map((rec, i) => (
                <tr key={i}>
                  <td>{rec.fechaMovimiento}</td>
                  <td style={{ fontWeight: 800 }}>{rec.noLote}</td>
                  <td>{rec.categoria}</td>
                  <td>{rec.clase}</td>
                  <td>{rec.ingredientes}</td>
                  <td>{rec.edad}</td>
                  <td style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {rec.observaciones}
                  </td>
                  <td style={{ fontSize: "11px" }}>{rec.inspector}</td>
                  <td>
                    <span className={`badge-status ${rec.status}`}>
                      {rec.status === "aprobado" ? "Aprobado" : rec.status === "revision" ? "En revisión" : "Borrador"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-fadeIn">
      <div className="history-section-header">
        <button onClick={() => setIsFormOpen(false)} className="btn-secondary-custom" style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px" }}>
          <ArrowBackIcon style={{ fontSize: 16 }} />
          <span>Volver al Historial</span>
        </button>
        <h2>Nuevo Registro de Maduración - Sección VII</h2>
      </div>

      <div className="cards-container-grid">
        {/* IDENTIFICACION DEL MEZCAL Y RECIPIENTES */}
        <section className="detail-card detail-card-accent-left-green">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <LayersIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Identificación y Contenedores</h2>
              <p>Especificaciones del lote y vasijas utilizadas</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <select 
                value={noLote} 
                onChange={e => setMadNoLote(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="manual">Ingreso Manual (Sin lote pre-registrado)</option>
                {(granelRecords || []).map((r, idx) => {
                  const fq = r.clave_fq || r.claveFQ || r.noAnalisis || r.noAnalisisFisicoquimico || r.no_analisis || "";
                  const maguey = r.tipoMaguey || r.especie || r.tipo_maguey || "";
                  const vol = r.invFinalVol !== undefined && r.invFinalVol !== "" ? r.invFinalVol : (r.litros || "");
                  return (
                    <option key={idx} value={r.noLote || r.id}>
                      {r.noLote || r.idContenedor} - {r.categoria || 'Mezcal'} ({r.clase || 'Blanco Joven'}){maguey ? ` [${maguey}]` : ''}{fq ? ` [FQ: ${fq}]` : ''} {vol ? `(Vol: ${vol} L)` : ''}
                    </option>
                  );
                })}
              </select>
              <label className="custom-input-label">Nº de Lote</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="date" 
                value={fechaMovimiento} 
                onChange={e => setFechaMovimiento(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Fecha del Movimiento</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <select 
                value={categoria} 
                onChange={e => setMadCategoria(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="Mezcal">Mezcal</option>
                <option value="Mezcal Artesanal">Mezcal Artesanal</option>
                <option value="Mezcal Ancestral">Mezcal Ancestral</option>
              </select>
              <label className="custom-input-label">Categoría</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={clase} 
                onChange={e => setMadClase(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. Joven / Reposado / Añejo"
              />
              <label className="custom-input-label">Clase</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                value={ingredientes} 
                onChange={e => setMadIngredientes(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Ingrediente(s)</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={edad} 
                onChange={e => setMadEdad(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Edad Inicial</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                value={tipoMaguey} 
                onChange={e => setMadTipoMaguey(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Tipo de Maguey(es)</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={noAnalisis} 
                onChange={e => setMadNoAnalisis(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Nº de Análisis Fisicoquímico</label>
            </div>
          </div>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--agave-green)", marginBottom: "8px", marginTop: "16px" }}>Tipo de Recipientes Utilizados</h3>
          <div className="species-grid">
            <div className="custom-input-group">
              <select 
                value={tipoRecipiente} 
                onChange={e => setMadTipoRecipiente(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="BARRICAS DE MADERA DE">BARRICAS DE MADERA DE</option>
                <option value="GARRAPAS DE VIDRIO">GARRAFAS DE VIDRIO</option>
              </select>
              <label className="custom-input-label">Recipiente</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={detalleRecipiente} 
                onChange={e => setMadDetalleRecipiente(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. Roble Americano medio tostado / Vidrio 10L"
              />
              <label className="custom-input-label">Detalle / Folio o Marca de Madera</label>
            </div>
          </div>
        </section>

        {/* INVENTARIOS Y ENTRADAS */}
        <section className="detail-card detail-card-accent-left-copper">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-copper">
              <ScienceIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Inventario Inicial & Entradas</h2>
              <p>Saldos de inicio y flujos de ingreso de mezcal</p>
            </div>
          </header>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--text-color)", marginBottom: "8px" }}>INVENTARIO INICIAL</h3>
          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="date" 
                value={invInicialFecha} 
                onChange={e => setMadInvInicialFecha(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Fecha de Ingreso</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                value={invInicialRecipientes} 
                onChange={e => setMadInvInicialRecipientes(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Recipientes Existentes</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                value={invInicialVolumen} 
                onChange={e => setMadInvInicialVolumen(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Volumen Neto (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                step="0.1"
                value={invInicialAlc} 
                onChange={e => setMadInvInicialAlc(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">% Alc. Vol.</label>
              <span className="input-suffix">%</span>
            </div>
          </div>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--agave-green)", marginBottom: "8px", marginTop: "16px" }}>ENTRADAS</h3>
          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                value={entradaFolio} 
                onChange={e => setMadEntradaFolio(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Folio de Ingreso</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                value={entradaRecipientes} 
                onChange={e => setMadEntradaRecipientes(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Nº de Recipientes</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                value={entradaVolumen} 
                onChange={e => setMadEntradaVolumen(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Volumen Neto (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                step="0.1"
                value={entradaAlc} 
                onChange={e => setMadEntradaAlc(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">% Alc. Vol.</label>
              <span className="input-suffix">%</span>
            </div>
          </div>
        </section>

        {/* SALIDAS Y INVENTARIO FINAL */}
        <section className="detail-card detail-card-accent-left-green" style={{ gridColumn: "1 / -1" }}>
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <WaterDropIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Salidas e Inventario Final</h2>
              <p>Volúmenes liberados, mermas de madera y saldo de cierre</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                value={salidaRecipientes} 
                onChange={e => setMadSalidaRecipientes(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Recipientes Liberados</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                value={salidaVolumen} 
                onChange={e => setMadSalidaVolumen(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Volumen Neto Salida (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                step="0.1"
                value={salidaAlc} 
                onChange={e => setMadSalidaAlc(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">% Alc. Vol. Salida</label>
              <span className="input-suffix">%</span>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                value={salidaClaseObtenida} 
                onChange={e => setMadSalidaClaseObtenida(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Clase Obtenida</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={salidaEdadObtenida} 
                onChange={e => setMadSalidaEdadObtenida(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Edad Obtenida</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                value={salidaMerma} 
                onChange={e => setMadSalidaMerma(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Volumen de Merma (L)</label>
              <span className="input-suffix" style={{ color: "var(--copper)" }}>Merma L</span>
            </div>
          </div>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--agave-green)", marginBottom: "8px", marginTop: "16px" }}>INVENTARIO FINAL</h3>
          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                value={invFinalRecipientes} 
                onChange={e => setMadInvFinalRecipientes(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Recipientes Existentes Finales</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                value={invFinalVolumen} 
                onChange={e => setMadInvFinalVolumen(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Volumen Neto Final (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                step="0.1"
                value={invFinalAlc} 
                onChange={e => setMadInvFinalAlc(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">% Alc. Vol. Final</label>
              <span className="input-suffix">%</span>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 20 }}>
            <textarea 
              value={observaciones} 
              onChange={e => setMadObservaciones(e.target.value)} 
              className="custom-input-field"
              style={{ height: "80px", resize: "none", padding: "14px" }}
              placeholder="Notas generales sobre la maduración..."
            />
            <label className="custom-input-label">Observaciones</label>
          </div>
        </section>
      </div>

      <div className="button-row">
        <button type="button" className="btn-secondary-custom" onClick={() => setIsFormOpen(false)}>Volver</button>
        <button 
          type="button" 
          className="btn-primary-custom" 
          onClick={() => handleSaveMaduracion("revision")}
        >
          <CheckCircleIcon style={{ fontSize: 16 }} />
          <span>Registrar Sección VII</span>
        </button>
      </div>
    </div>
  );
};

export default InventarioMaduracionSection;
